import { TabList, Tab, Tabs, Text } from '@grupoboticario/flora-react';
import { useHistoryWithHost } from 'routes/useHistoryWithHost';
import { useContext, useEffect } from 'react';
import { globalContext } from 'context/global';
import { ROUTE_PATH } from 'config/routes';
import { getRoleList } from 'store/modules/roles/actions';
import { ApplicationState } from 'store/store.inteface';
import { useDispatch, useSelector } from 'react-redux';
import { MENU } from './data';
import { Container } from './styles';

export const Menu = () => {
  const { path } = useContext(globalContext);
  const dispatch = useDispatch();
  const { rolesList } = useSelector((state: ApplicationState) => state.roles);
  const { location, push } = useHistoryWithHost();

  useEffect(() => {
    dispatch(getRoleList());
  }, [dispatch]);

  function getActiveTab() {
    const activeTab = location.pathname.substring(path.length);

    switch (activeTab) {
      case ROUTE_PATH.HOME:
        return ROUTE_PATH.HOME;

      case ROUTE_PATH.EMPTY:
        return ROUTE_PATH.HOME;

      case ROUTE_PATH.CERTIFICATES:
        return ROUTE_PATH.CERTIFICATES;

      case ROUTE_PATH.REPORTS:
        return ROUTE_PATH.REPORTS;

      case ROUTE_PATH.KNOWLEDGE_PORTAL:
        return ROUTE_PATH.KNOWLEDGE_PORTAL;

      default:
        return ROUTE_PATH.HOME;
    }
  }

  const tabs = MENU.filter(route =>
    route.roles.some(role => rolesList.includes(role)),
  );

  return (
    <Container>
      <Tabs defaultValue={getActiveTab()}>
        <TabList area-aria-label="tabs">
          {tabs.map((tab: any, index) => {
            const key = `Tab-${index}`;
            return (
              <Tab
                key={key}
                icon={tab.icon}
                value={tab.path}
                onClick={() => push(tab.path)}
              >
                <Text>{tab.name}</Text>
              </Tab>
            );
          })}
        </TabList>
      </Tabs>
    </Container>
  );
};
